import axios from "../axios";
import { BASE_URL, initApi } from "../initApi";

// ----------------------- APP - PRODUCT - GET PRODUCT
export async function getProduct(productId, searchId) {
  return initApi().then(() => {
    const params = searchId ? `?searchId=${encodeURIComponent(searchId)}` : "";
    return axios.get(`${BASE_URL}/api/product/${productId}${params}`);
  });
}
// ----------------------- APP - PRODUCT - GET PRODUCT By NUMBER
export async function getProductsByNumber(params) {
  return initApi().then(() => {
    return axios.get(`${BASE_URL}/api/product/by-product-nr?${params}`);
  });
}

// ----------------------- APP - PRODUCT - SEARCH PRODUCT
export async function searchProduct(query) {
  return initApi().then(() => {
    return axios.post(`${BASE_URL}/api/product/search`, query);
  });
}
// ----------------------- APP - PRODUCT - Auto Complete
export async function autoComplete(searchStr) {
  return initApi().then(() => {
    return axios.get(
      `${BASE_URL}/api/product/auto-complete?searchString=${searchStr}`,
    );
  });
}

// ----------------------- APP - PRODUCT - FILTER PRODUCT
export async function filterProduct(query) {
  return initApi().then(() => {
    return axios.post(`${BASE_URL}/api/product/filter`, query);
  });
}

// ----------------------- APP - PRODUCT - SEARCH-SIMPLE PRODUCT
export async function searchSimpleProduct(query) {
  return initApi().then(() => {
    return axios.post(`${BASE_URL}/api/product/search-simple`, query);
  });
}
// ----------------------- APP - PRODUCT - GET LANDING PAGE DEALS
export async function getLandingPageDeals() {
  return initApi().then(() => {
    return axios.get(`${BASE_URL}/api/product/landing-page`);
  });
}
// ----------------------- APP - PRODUCT - GET RANDOM LANDING PAGE DEALS
export async function getLandingPageDealsRandom(amount) {
  return initApi().then(() => {
    return axios.get(
      `${BASE_URL}/api/product/landing-page/random?amount=${amount}`,
    );
  });
}

// ----------------------- APP - PRODUCT - PUT LANDING PAGE DEALS
export async function setLandingPageDeals(dealsArray) {
  return initApi().then(() => {
    return axios.put(`${BASE_URL}/api/product/landing-page`, {
      productNrs: dealsArray,
    });
  });
}

// ----------------------- APP - PRODUCT - GET HIGHLIGHTED PRODUCTS
export async function getHighlightedProducts() {
  return initApi().then(() => {
    return axios.get(`${BASE_URL}/api/product/highlighted`);
  });
}
// ----------------------- APP - PRODUCT - PUT HIGHLIGHTED PRODUCTS
export async function setHighlightedProducts(productNrs) {
  return initApi().then(() => {
    return axios.put(`${BASE_URL}/api/product/highlighted`, {
      productNrs: productNrs,
    });
  });
}

// ----------------------- APP - PRODUCT - GET "NEW" PRODUCTS
export async function getNewHighlightProducts() {
  return initApi().then(() => {
    return axios.get(`${BASE_URL}/api/product/new`);
  });
}
// ----------------------- APP - PRODUCT - PUT "NEW" PRODUCTS
export async function setNewHighlightProducts(productNrs) {
  return initApi().then(() => {
    return axios.put(`${BASE_URL}/api/product/new`, {
      productNrs: productNrs,
    });
  });
}
